module.exports = __webpack_public_path__ + "static/img/0_1_2.196b7298.jpg";